// extracted by mini-css-extract-plugin
module.exports = {"description":"specialties_description__EX4xc"};